export const profileAvatars = [
    {
        id: 1,
        name: "Profile 1",
        image: "https://inboxlogy-cdn.s3.us-east-1.amazonaws.com/assets/svg/a1.svg"
    },
    {
        id: 2,
        name: "Profile 2",
        image: "https://inboxlogy-cdn.s3.us-east-1.amazonaws.com/assets/svg/a2.svg"
    },
    {
        id: 3,
        name: "Profile 3",
        image: "https://inboxlogy-cdn.s3.us-east-1.amazonaws.com/assets/svg/a3.svg"
    },
    {
        id: 4,
        name: "Profile 4",
        image: "https://inboxlogy-cdn.s3.us-east-1.amazonaws.com/assets/svg/a4.svg"
    },
    {
        id: 5,
        name: "Profile 5",
        image: "https://inboxlogy-cdn.s3.us-east-1.amazonaws.com/assets/svg/a5.svg"
    },
    {
        id: 6,
        name: "Profile 6",
        image: "https://inboxlogy-cdn.s3.us-east-1.amazonaws.com/assets/svg/a6.svg"
    },
    {
        id: 7,
        name: "Profile 7",
        image: "https://inboxlogy-cdn.s3.us-east-1.amazonaws.com/assets/svg/a7.svg"
    },
    {
        id: 8,
        name: "Profile 8",
        image: "https://inboxlogy-cdn.s3.us-east-1.amazonaws.com/assets/svg/a8.svg"
    },
    {
        id: 9,
        name: "Profile 9",
        image: "https://inboxlogy-cdn.s3.us-east-1.amazonaws.com/assets/svg/a9.svg"
    },
    {
        id: 10,
        name: "Profile 10",
        image: "https://inboxlogy-cdn.s3.us-east-1.amazonaws.com/assets/svg/a10.svg"
    },
    {
        id: 11,
        name: "Profile 11",
        image: "https://inboxlogy-cdn.s3.us-east-1.amazonaws.com/assets/svg/a11.svg"
    },
    {
        id: 12,
        name: "Profile 12",
        image: "https://inboxlogy-cdn.s3.us-east-1.amazonaws.com/assets/svg/a12.svg"
    },
    {
        id: 13,
        name: "Profile 13",
        image: "https://inboxlogy-cdn.s3.us-east-1.amazonaws.com/assets/svg/a13.svg"
    },
    {
        id: 14,
        name: "Profile 14",
        image: "https://inboxlogy-cdn.s3.us-east-1.amazonaws.com/assets/svg/a14.svg"
    },
    {
        id: 15,
        name: "Profile 15",
        image: "https://inboxlogy-cdn.s3.us-east-1.amazonaws.com/assets/svg/a15.svg"
    },
    {
        id: 16,
        name: "Profile 16",
        image: "https://inboxlogy-cdn.s3.us-east-1.amazonaws.com/assets/svg/a16.svg"
    }
]